<div class="home-container">

  <!-- Loading while checking authentication -->
  <div class="auth-check-loading" *ngIf="isCheckingAuth">
    <div class="loading-content">
      <div class="spinner"></div>
      <h3>Verificando sesion...</h3>
      <p>Un momento por favor</p>
    </div>
  </div>

  <!-- Mobile-first: login on top, tagline below -->
  <div class="home-layout" *ngIf="!isCheckingAuth">

    <!-- Login card -->
    <div class="auth-section">
      <app-login></app-login>
    </div>

    <!-- Tagline + features at bottom -->
    <div class="hero-text">
      <p class="hero-tagline">
        Pide desde tu mesa, reserva y explora restaurantes cerca de ti.
      </p>
      <div class="features-inline">
        <div class="feature-chip"><span>📱</span> Escanea y pide</div>
        <div class="feature-chip"><span>📅</span> Reserva mesa</div>
        <div class="feature-chip"><span>📍</span> Lugares cercanos</div>
        <div class="feature-chip"><span>⚡</span> Instala como app</div>
      </div>
    </div>

  </div>

</div>
